import { render, staticRenderFns } from "./studentChangePageButton.vue?vue&type=template&id=7d60b5df&scoped=true"
import script from "./studentChangePageButton.vue?vue&type=script&lang=js"
export * from "./studentChangePageButton.vue?vue&type=script&lang=js"
import style0 from "./studentChangePageButton.vue?vue&type=style&index=0&id=7d60b5df&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d60b5df",
  null
  
)

export default component.exports